/**
 * @voltxampere/engine — Capacitor AC stamp (Sprint 20)
 *
 * The AC admittance of a capacitor is `Y_C = jωC` — pure imaginary,
 * scaling linearly with the sweep frequency. Open at DC (ω=0) collapses
 * the contribution to zero, which keeps the SPICE convention that the
 * DC operating point pre-pass already saw a capacitor as an open
 * circuit.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { StampParameterError } from "@voltxampere/shared";
import { getNumericParam, getTerminalNetId } from "../terminal-utils.js";
export const capacitorACStamp = (ctx, component) => {
    const c = getNumericParam(component, "capacitance");
    if (!(c > 0) || !Number.isFinite(c)) {
        throw new StampParameterError(`capacitorACStamp: component "${component.id}" has non-positive capacitance ${String(c)}`, {
            meta: {
                stampType: "capacitor",
                parameter: "capacitance",
                received: c,
                expected: "> 0 and finite",
                componentId: component.id,
            },
        });
    }
    const susceptance = ctx.omega * c; // im part of jωC
    const a = ctx.nodeIndex(getTerminalNetId(component, "p1"));
    const b = ctx.nodeIndex(getTerminalNetId(component, "p2"));
    ctx.addY(a, a, 0, susceptance);
    ctx.addY(b, b, 0, susceptance);
    ctx.addY(a, b, 0, -susceptance);
    ctx.addY(b, a, 0, -susceptance);
};
//# sourceMappingURL=capacitor.js.map